module.exports = __webpack_public_path__ + "img/project-tasks-remaining.1ddf806b.svg";